import { assertResolvedAtsNotHttpError } from '@/api/ats/atsEnvelope';
import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/ats-https';

export interface UserGroup {
  category: string;
  id: number;
  members_count: number;
  name: string;
}

interface GetUserGroupsApiResponse {
  data: UserGroup[];
  errors: string[];
}

export const useGetUserGroups = (
  type: string = 'ats_interviewer_pool'
) => {
  const query = useQuery<GetUserGroupsApiResponse, Error>({
    queryKey: ['get-user-groups', type],
    queryFn: async () => {
      const res = await http.get<GetUserGroupsApiResponse>(
        `user_groups?type=${type}`
      );
      assertResolvedAtsNotHttpError(res);
      return res as unknown as GetUserGroupsApiResponse;
    },
    staleTime: 0,
  });

  const userGroups = query?.data?.data ?? [];
  const uiError = query?.data?.errors ?? [];

  return { userGroups, uiError, ...query };
};
